/**
 * 🎨 Color Derivations
 *
 * Функции для вычисления производных цветов на основе базовых токенов.
 * Единое решение на уровне UI Kit - никаких хардкодов в темах.
 */

import type { ThemeTokens } from './semantic';

/**
 * Вычисляет primaryLight (светлый вариант primary для hover/selected)
 * на основе базового primary цвета
 */
export function derivePrimaryLight(primary: string): string {
  // Для желтого primary (#FFC107) - светло-желтый
  if (primary === '#FFC107') return '#FFECB3';

  // Для оливкового primary (#556B2F) - темно-оливковый (темнее для лучшего контраста)
  if (primary === '#556B2F') return '#A8C68C';

  // Для розового primary (#F48FB1) - светло-розовый
  if (primary === '#F48FB1') return '#FCE4EC';

  // Для других цветов - осветляем на 30% (простая логика)
  // В реальном проекте можно использовать более сложную логику с HSL
  return primary; // fallback
}

/**
 * Вычисляет onPrimaryContainer (цвет текста на primaryLight фоне)
 * Светлые темы: тёмный глиф на светлой primary-плашке.
 * Только dark: светлый глиф на приглушённом primary-container (как M3 / system dark).
 */
export function deriveOnPrimaryContainer(themeType: 'light' | 'dark' | 'olive' | 'pink'): string {
  if (themeType === 'dark') {
    return '#E8E1D4';
  }
  return '#1B1B1B';
}

/**
 * Создает полные ThemeTokens с вычисленными производными цветами
 */
export function createThemeWithDerivations(baseTokens: Omit<ThemeTokens, 'primaryLight' | 'onPrimaryContainer'>, themeType: 'light' | 'dark' | 'olive' | 'pink'): ThemeTokens {
  const primaryLight = derivePrimaryLight(baseTokens.primary);
  const onPrimaryContainer = deriveOnPrimaryContainer(themeType);

  return {
    ...baseTokens,
    primaryLight,
    onPrimaryContainer,
  };
}